export const getJobTypeOptions = (jobTypes = []) =>
  (jobTypes || [])
    .map(item => ({
      label: item.description,
      value: item.id,
      inactive: item.active !== 1,
    }))
    .sort(
      (first, second) =>
        Number(first.inactive) - Number(second.inactive) ||
        (first.label || "").localeCompare(second.label || ""),
    );

const inactiveTextStyle = (base, { data }) => ({
  ...base,
  ...(data.inactive ? { color: "#6b7280" } : {}),
});

export const jobTypeStyles = {
  option: inactiveTextStyle,
  singleValue: inactiveTextStyle,
};
